import Vue from "vue";

const VUE = new Vue()
export default VUE;